import React from 'react'
import PropTypes from 'prop-types'
import { getPlainText } from 'commons/plainText'
import RichTextDisplay from 'app/components/richTextEditor/RichTextDisplay'

const PlainText = (props) => {
  const { text } = props
  return <RichTextDisplay text={getPlainText(text ?? '')} />
}

PlainText.propTypes = {
  text: PropTypes.string,
}

export default PlainText
